import { jsx, jsxs } from 'react/jsx-runtime';
import '../../../d3-array/dist/d3-array.js';
import '../../../d3-interpolate/dist/d3-interpolate.js';
import './../../../d3-scale/external_lib/d3-format/src/defaultLocale.js';
import './../../../d3-scale/external_lib/d3-format/src/formatSpecifier.js';
import '../../../d3-time/src/millisecond.js';
import '../../../d3-time/src/second.js';
import '../../../d3-time/src/minute.js';
import '../../../d3-time/src/hour.js';
import '../../../d3-time/src/day.js';
import '../../../d3-time/src/week.js';
import '../../../d3-time/src/month.js';
import '../../../d3-time/src/year.js';
import '../../../d3-time/src/utcMinute.js';
import '../../../d3-time/src/utcHour.js';
import '../../../d3-time/src/utcDay.js';
import '../../../d3-time/src/utcWeek.js';
import '../../../d3-time/src/utcMonth.js';
import '../../../d3-time/src/utcYear.js';
import '../../../d3-time-format/src/defaultLocale.js';
import '../../../d3-time-format/src/isoFormat.js';
import '../../../d3-time-format/src/isoParse.js';
import { useTheme as Et } from '../../core/dist/nivo-core.es.js';
import '../../colors/dist/nivo-colors.es.js';
import * as React from 'react';
import { useState, useCallback } from 'react';
import '../../../prop-types/index.js';
import { exports as propTypesExports } from '../../../../_virtual/index2.js';
var m = function (e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("circle", {
      r: o / 2,
      cx: i + o / 2,
      cy: n + o / 2,
      fill: r,
      opacity: a,
      strokeWidth: s,
      stroke: void 0 === d ? "transparent" : d,
      style: {
        pointerEvents: "none"
      }
    });
  },
  f = function (e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("g", {
      transform: "translate(" + i + "," + n + ")",
      children: jsx("path", {
        d: "\n                    M" + o / 2 + " 0\n                    L" + .8 * o + " " + o / 2 + "\n                    L" + o / 2 + " " + o + "\n                    L" + .2 * o + " " + o / 2 + "\n                    L" + o / 2 + " 0\n                ",
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        style: {
          pointerEvents: "none"
        }
      })
    });
  },
  u = function (e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("rect", {
      x: i,
      y: n,
      fill: r,
      opacity: a,
      strokeWidth: s,
      stroke: void 0 === d ? "transparent" : d,
      width: o,
      height: o,
      style: {
        pointerEvents: "none"
      }
    });
  },
  v = function (e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("g", {
      transform: "translate(" + i + "," + n + ")",
      children: jsx("path", {
        d: "\n                M" + o / 2 + " 0\n                L" + o + " " + o + "\n                L0 " + o + "\n                L" + o / 2 + " 0\n            ",
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        style: {
          pointerEvents: "none"
        }
      })
    });
  };
function p() {
  return p = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, p.apply(this, arguments);
}
var b = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  k = function (t) {
    var e,
      i = t.direction,
      n = t.itemsSpacing,
      o = t.padding,
      r = t.itemCount,
      l = t.itemWidth,
      a = t.itemHeight;
    if ("number" != typeof o && ("object" != typeof (e = o) || Array.isArray(e) || null === e)) throw new Error("Invalid property padding, must be one of: number, object");
    var c = "number" == typeof o ? {
        top: o,
        right: o,
        bottom: o,
        left: o
      } : p({}, b, o),
      s = c.left + c.right,
      d = c.top + c.bottom,
      h = l + s,
      g = a + d,
      m = (r - 1) * n;
    return "row" === i ? h = l * r + m + s : "column" === i && (g = a * r + m + d), {
      width: h,
      height: g,
      padding: c
    };
  },
  x = function (t) {
    var e = t.anchor,
      i = t.translateX,
      n = t.translateY,
      o = t.containerWidth,
      r = t.containerHeight,
      l = t.width,
      a = t.height,
      c = i,
      s = n;
    switch (e) {
      case "top":
        c += (o - l) / 2;
        break;
      case "top-right":
        c += o - l;
        break;
      case "right":
        c += o - l, s += (r - a) / 2;
        break;
      case "bottom-right":
        c += o - l, s += r - a;
        break;
      case "bottom":
        c += (o - l) / 2, s += r - a;
        break;
      case "bottom-left":
        s += r - a;
        break;
      case "left":
        s += (r - a) / 2;
        break;
      case "center":
        c += (o - l) / 2, s += (r - a) / 2;
    }
    return {
      x: c,
      y: s
    };
  },
  S = function (t) {
    var e,
      i,
      n,
      o,
      r,
      l,
      a = t.direction,
      c = t.justify,
      s = t.symbolSize,
      d = t.symbolSpacing,
      h = t.width,
      g = t.height;
    switch (a) {
      case "left-to-right":
        e = 0, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = h, r = "end") : (n = s + d, r = "start");
        break;
      case "right-to-left":
        e = h - s, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = 0, r = "start") : (n = h - s - d, r = "end");
        break;
      case "top-to-bottom":
        e = (h - s) / 2, i = 0, n = h / 2, r = "middle", c ? (o = g, l = "alphabetic") : (o = s + d, l = "text-before-edge");
        break;
      case "bottom-to-top":
        e = (h - s) / 2, i = g - s, n = h / 2, r = "middle", c ? (o = 0, l = "text-before-edge") : (o = g - s - d, l = "alphabetic");
    }
    return {
      symbolX: e,
      symbolY: i,
      labelX: n,
      labelY: o,
      labelAnchor: r,
      labelAlignment: l
    };
  },
  C = {
    circle: m,
    diamond: f,
    square: u,
    triangle: v
  },
  B = function (i) {
    var n,
      r,
      l,
      c,
      h,
      g,
      m,
      f,
      u,
      v,
      y,
      b = i.x,
      k = i.y,
      x = i.width,
      A = i.height,
      W = i.data,
      O = i.direction,
      z = void 0 === O ? "left-to-right" : O,
      B = i.justify,
      w = void 0 !== B && B,
      X = i.textColor,
      Y = i.background,
      H = void 0 === Y ? "transparent" : Y,
      E = i.opacity,
      j = void 0 === E ? 1 : E,
      T = i.symbolShape,
      L = void 0 === T ? "square" : T,
      M = i.symbolSize,
      F = void 0 === M ? 16 : M,
      P = i.symbolSpacing,
      R = void 0 === P ? 8 : P,
      q = i.symbolBorderWidth,
      V = void 0 === q ? 0 : q,
      D = i.symbolBorderColor,
      G = void 0 === D ? "transparent" : D,
      I = i.onClick,
      N = i.onMouseEnter,
      _ = i.onMouseLeave,
      J = i.toggleSerie,
      K = i.effects,
      Q = useState({}),
      U = Q[0],
      Z = Q[1],
      $ = Et(),
      tt = useCallback(function (t) {
        if (K) {
          var e = K.filter(function (t) {
            return "hover" === t.on;
          }).reduce(function (t, e) {
            return p({}, t, e.style);
          }, {});
          Z(e);
        }
        null == N || N(W, t);
      }, [N, W, K]),
      et = useCallback(function (t) {
        if (K) {
          var e = K.filter(function (t) {
            return "hover" !== t.on;
          }).reduce(function (t, e) {
            return p({}, t, e.style);
          }, {});
          Z(e);
        }
        null == _ || _(W, t);
      }, [_, W, K]),
      it = S({
        direction: z,
        justify: w,
        symbolSize: null != (n = U.symbolSize) ? n : F,
        symbolSpacing: R,
        width: x,
        height: A
      }),
      nt = it.symbolX,
      ot = it.symbolY,
      rt = it.labelX,
      lt = it.labelY,
      at = it.labelAnchor,
      ct = it.labelAlignment,
      st = [I, N, _, J].some(function (t) {
        return void 0 !== t;
      }),
      dt = "function" == typeof L ? L : C[L];
    return jsxs("g", {
      transform: "translate(" + b + "," + k + ")",
      style: {
        opacity: null != (r = U.itemOpacity) ? r : j
      },
      children: [jsx("rect", {
        width: x,
        height: A,
        fill: null != (l = U.itemBackground) ? l : H,
        style: {
          cursor: st ? "pointer" : "auto"
        },
        onClick: function (t) {
          null == I || I(W, t), null == J || J(W.id);
        },
        onMouseEnter: tt,
        onMouseLeave: et
      }), React.createElement(dt, p({
        id: W.id,
        x: nt,
        y: ot,
        size: null != (c = U.symbolSize) ? c : F,
        fill: null != (h = null != (g = W.fill) ? g : W.color) ? h : "black",
        borderWidth: null != (m = U.symbolBorderWidth) ? m : V,
        borderColor: null != (f = U.symbolBorderColor) ? f : G
      }, W.hidden ? $.legends.hidden.symbol : void 0)), jsx("text", {
        textAnchor: at,
        style: p({}, $.legends.text, {
          fill: null != (u = null != (v = null != (y = U.itemTextColor) ? y : X) ? v : $.legends.text.fill) ? u : "black",
          dominantBaseline: ct,
          pointerEvents: "none",
          userSelect: "none"
        }, W.hidden ? $.legends.hidden.text : void 0),
        x: rt,
        y: lt,
        children: W.label
      })]
    });
  },
  w = function (e) {
    var i = e.data,
      n = e.x,
      o = e.y,
      r = e.direction,
      l = e.padding,
      a = void 0 === l ? 0 : l,
      c = e.justify,
      s = e.effects,
      d = e.itemWidth,
      h = e.itemHeight,
      g = e.itemDirection,
      m = void 0 === g ? "left-to-right" : g,
      f = e.itemsSpacing,
      u = void 0 === f ? 0 : f,
      v = e.itemTextColor,
      p = e.itemBackground,
      y = void 0 === p ? "transparent" : p,
      b = e.itemOpacity,
      x = void 0 === b ? 1 : b,
      S = e.symbolShape,
      A = e.symbolSize,
      W = e.symbolSpacing,
      O = e.symbolBorderWidth,
      z = e.symbolBorderColor,
      C = e.onClick,
      w = e.onMouseEnter,
      X = e.onMouseLeave,
      Y = e.toggleSerie,
      H = k({
        itemCount: i.length,
        itemWidth: d,
        itemHeight: h,
        itemsSpacing: u,
        direction: r,
        padding: a
      }).padding,
      E = "row" === r ? d + u : 0,
      j = "column" === r ? h + u : 0;
    return jsx("g", {
      transform: "translate(" + n + "," + o + ")",
      children: i.map(function (e, i) {
        return jsx(B, {
          data: e,
          x: i * E + H.left,
          y: i * j + H.top,
          width: d,
          height: h,
          direction: m,
          justify: c,
          effects: s,
          textColor: v,
          background: y,
          opacity: x,
          symbolShape: S,
          symbolSize: A,
          symbolSpacing: W,
          symbolBorderWidth: O,
          symbolBorderColor: z,
          onClick: C,
          onMouseEnter: w,
          onMouseLeave: X,
          toggleSerie: Y
        }, i);
      })
    });
  },
  X = function (e) {
    var i = e.data,
      n = e.containerWidth,
      o = e.containerHeight,
      r = e.translateX,
      l = void 0 === r ? 0 : r,
      a = e.translateY,
      c = void 0 === a ? 0 : a,
      s = e.anchor,
      d = e.direction,
      h = e.padding,
      g = void 0 === h ? 0 : h,
      m = e.justify,
      f = e.itemsSpacing,
      u = void 0 === f ? 0 : f,
      v = e.itemWidth,
      p = e.itemHeight,
      y = e.itemDirection,
      b = e.itemTextColor,
      S = e.itemBackground,
      A = e.itemOpacity,
      W = e.symbolShape,
      O = e.symbolSize,
      z = e.symbolSpacing,
      C = e.symbolBorderWidth,
      B = e.symbolBorderColor,
      X = e.onClick,
      Y = e.onMouseEnter,
      H = e.onMouseLeave,
      E = e.toggleSerie,
      j = e.effects,
      T = k({
        itemCount: i.length,
        itemsSpacing: u,
        itemWidth: v,
        itemHeight: p,
        direction: d,
        padding: g
      }),
      L = T.width,
      M = T.height,
      F = x({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: L,
        height: M
      }),
      P = F.x,
      R = F.y;
    return jsx(w, {
      data: i,
      x: P,
      y: R,
      direction: d,
      padding: g,
      justify: m,
      effects: j,
      itemsSpacing: u,
      itemWidth: v,
      itemHeight: p,
      itemDirection: y,
      itemTextColor: b,
      itemBackground: S,
      itemOpacity: A,
      symbolShape: W,
      symbolSize: O,
      symbolSpacing: z,
      symbolBorderWidth: C,
      symbolBorderColor: B,
      onClick: X,
      onMouseEnter: Y,
      onMouseLeave: H,
      toggleSerie: "boolean" == typeof E ? void 0 : E
    });
  },
  Y = {
    start: "left",
    middle: "center",
    end: "right"
  },
  H = function (t, e) {
    var i = e.data,
      n = e.containerWidth,
      o = e.containerHeight,
      r = e.translateX,
      l = void 0 === r ? 0 : r,
      a = e.translateY,
      c = void 0 === a ? 0 : a,
      s = e.anchor,
      d = e.direction,
      h = e.padding,
      g = void 0 === h ? 0 : h,
      m = e.justify,
      f = void 0 !== m && m,
      u = e.itemsSpacing,
      v = void 0 === u ? 0 : u,
      p = e.itemWidth,
      y = e.itemHeight,
      b = e.itemDirection,
      A = void 0 === b ? "left-to-right" : b,
      W = e.itemTextColor,
      O = e.symbolSize,
      z = void 0 === O ? 16 : O,
      C = e.symbolSpacing,
      B = void 0 === C ? 8 : C,
      w = e.theme,
      X = k({
        itemCount: i.length,
        itemWidth: p,
        itemHeight: y,
        itemsSpacing: v,
        direction: d,
        padding: g
      }),
      H = X.width,
      E = X.height,
      j = X.padding,
      T = x({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: H,
        height: E
      }),
      L = T.x,
      M = T.y,
      F = "row" === d ? p + v : 0,
      P = "column" === d ? y + v : 0;
    t.save(), t.translate(L, M), t.font = w.legends.text.fontSize + "px " + (w.legends.text.fontFamily || "sans-serif"), i.forEach(function (e, i) {
      var n,
        o,
        r = i * F + j.left,
        l = i * P + j.top,
        a = S({
          direction: A,
          justify: f,
          symbolSize: z,
          symbolSpacing: B,
          width: p,
          height: y
        }),
        c = a.symbolX,
        s = a.symbolY,
        d = a.labelX,
        h = a.labelY,
        g = a.labelAnchor,
        m = a.labelAlignment;
      t.fillStyle = null != (n = e.color) ? n : "black", t.fillRect(r + c, l + s, z, z), t.textAlign = Y[g], "central" === m && (t.textBaseline = "middle"), t.fillStyle = null != (o = null != W ? W : w.legends.text.fill) ? o : "black", t.fillText(String(e.label), r + d, l + h);
    }), t.restore();
  },
  T = {
    data: propTypesExports.arrayOf(propTypesExports.object),
    anchor: propTypesExports.oneOf(["top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", "center"]).isRequired,
    translateX: propTypesExports.number,
    translateY: propTypesExports.number,
    direction: propTypesExports.oneOf(["row", "column"]).isRequired,
    itemsSpacing: propTypesExports.number,
    itemWidth: propTypesExports.number.isRequired,
    itemHeight: propTypesExports.number.isRequired,
    itemDirection: propTypesExports.oneOf(["left-to-right", "right-to-left", "top-to-bottom", "bottom-to-top"]),
    itemTextColor: propTypesExports.string,
    itemBackground: propTypesExports.string,
    itemOpacity: propTypesExports.number,
    symbolShape: propTypesExports.oneOfType([propTypesExports.oneOf(["circle", "diamond", "square", "triangle"]), propTypesExports.func]),
    symbolSize: propTypesExports.number,
    symbolSpacing: propTypesExports.number,
    symbolBorderWidth: propTypesExports.number,
    symbolBorderColor: propTypesExports.string,
    onClick: propTypesExports.func,
    onMouseEnter: propTypesExports.func,
    onMouseLeave: propTypesExports.func,
    effects: propTypesExports.arrayOf(propTypesExports.shape({
      on: propTypesExports.oneOfType([propTypesExports.oneOf(["hover"])]).isRequired,
      style: propTypesExports.shape({
        itemTextColor: propTypesExports.string,
        itemBackground: propTypesExports.string,
        itemOpacity: propTypesExports.number,
        symbolSize: propTypesExports.number,
        symbolBorderWidth: propTypesExports.number,
        symbolBorderColor: propTypesExports.string
      }).isRequired
    }))
  };
export { X as BoxLegendSvg, T as LegendPropShape, w as LegendSvg, B as LegendSvgItem, m as SymbolCircle, f as SymbolDiamond, u as SymbolSquare, v as SymbolTriangle, k as computeDimensions, S as computeItemLayout, x as computePositionFromAnchor, H as renderLegendToCanvas };
//# sourceMappingURL=nivo-legends.es.js.map
